<!-- components\newhome\resenas\VideosGrid.vue -->
<template>
  <div class="bg-GRIS_CLARO w-full flex flex-col mt-6 md:mt-6 mb-0 md:my-6 items-center">
    <div class="max-w-[76rem] w-full flex flex-col justify-self-center my-10 gap-5">
      <div class="flex flex-col text-center md:flex-row justify-center items-center gap-3">
        <img src="/img/newhome/resenas/star-hand.gif" alt="resenas" class="w-[70px] h-[70px]" loading="lazy" decoding="async" />
        <h2 class="font-bold md:text-2xl text-lg">Más de 1000 Personas han confiado en nosotros</h2>
      </div>
      <p class="font-semibold md:text-lg text-base text-center max-w-[700px] mx-auto">Gracias a nuestro compromiso, seguimos construyendo experiencias únicas que nos posicionan como tu mejor opción. A continuación te presentamos algunos testimonios de nuestros clientes</p>

      <!-- Carrusel Desktop (3 por página) -->
      <Carrusel
        class="hidden md:block"
        :data="videosData"
        :itemsPorPagina="3"
        :autoplay="false"
        :bucle="videosData.length > 3"
        :habilitarBotonesNav="videosData.length > 3"
        customBotonesNavClass="p-1 md:p-2 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
        customIconClass="text-current w-5 h-5"
        customPrevPosition="left-[-2rem]"
        customNextPosition="right-[-2rem]"
        :motrarPuntos="videosData.length > 3"
        PadreDotClass="flex justify-center mt-4"
        customDotClass="w-3 h-3"
        customActiveDotClass="bg-ROJO_LEON w-6"
        customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2"
        ClaseSlide="flex flex-row gap-5 justify-items-center py-5 px-2">
        <template #contenido="{ items }">
          <div class="grid grid-cols-3 gap-5 w-full justify-items-center">
            <VideoCard v-for="(video, index) in items" :key="index" :data="video" />
          </div>
        </template>
      </Carrusel>

      <!-- Carrusel Mobile (1 por página) -->
      <Carrusel
        class="block md:hidden"
        :data="videosData"
        :itemsPorPagina="1"
        :autoplay="false"
        :bucle="videosData.length > 1"
        :habilitarBotonesNav="videosData.length > 1"
        customBotonesNavClass="p-1 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
        customIconClass="text-current w-5 h-5"
        customPrevPosition="left-2"
        customNextPosition="right-2"
        :motrarPuntos="videosData.length > 1"
        PadreDotClass="flex justify-center mt-4"
        customDotClass="w-2 h-2"
        customActiveDotClass="bg-ROJO_LEON w-6"
        customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2"
        ClaseSlide="flex flex-row gap-5 justify-items-center py-5 px-2">
        <template #contenido="{ items }">
          <div class="flex justify-center w-full">
            <VideoCard v-for="(video, index) in items" :key="index" :data="video" />
          </div>
        </template>
      </Carrusel>

    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { aliasSistemas } from '@/constants/aliasSistemas';
import Carrusel from '~/components/Carruseles/Carrusel.vue';
import VideoCard from '~/components/newhome/resenas/VideoCard.vue';

const config = useRuntimeConfig();
const modo_sistema = useState('modo_sistema');
const alias = computed(() => aliasSistemas[modo_sistema.value]);

const debug = {
  enabled: config.public.modo === 'DEV',
  log:   (...args) => debug.enabled && console.log(...args),
  error: (...args) => debug.enabled && console.error(...args),
};

const { data: apiResponse, status } = await useFetch('/api/recursos', {
  query: { action: 'getVideosData', alias: alias.value },
  lazy: true,
  watch: [alias],
});

const videosFallback = [
  { nombre: 'video1', img: '/img/newhome/resenas/frame1.png', video: '/img/newhome/resenas/video-1.mp4' },
  { nombre: 'video2', img: '/img/newhome/resenas/frame2.png', video: '/img/newhome/resenas/video-2.mp4' },
  { nombre: 'video3', img: '/img/newhome/resenas/frame3.png', video: '/img/newhome/resenas/video-3.mp4' },
];

const videosData = computed(() => {
  debug.log('[VIDEOS] apiResponse:', apiResponse.value);

  if (apiResponse.value?.status === 'success' && Array.isArray(apiResponse.value?.data) && apiResponse.value.data.length > 0) {
    return apiResponse.value.data.slice(0, 6).map(item => ({
      nombre: item.nombre || '',
      img:    item.url_frame_desktop,
      video:  item.url_video_desktop,
    }));
  }

  return videosFallback;
});
</script>

<style scoped>
.videos-grid {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow: auto;
}
.videos-grid::-webkit-scrollbar {
  display: none;
}
</style>